// @it-enterprise пакеты
import GrapgQlCore from '@it-enterprise/graphql'
import Localization from '@it-enterprise/localization'

import auth from '@it-enterprise/jwtauthentication'



auth.config(
  {
    baseUrl: window.appConfig.GrapgQlUrl,
    onError: e => {
      //console.log('', e.response.status, e.response.status === 400)
      switch (true) {
      case e.response && e.response.status === 400:
        auth.clearTokens()
        Vue.$routerCore.GoToSignIn()
        break
      case e.response && e.response.status <= 500:
        
        throw new Error(e)
        
      default: 
      //console.log(e)
      }
    }
  }
)


import './plugins/pagePlayer'
import registerAppRuntime from '@/plugins/appRuntime.js'

// vue пакеты
import Vue from 'vue'
import axios from 'axios'
import { i18n } from './plugins/i18n'
import store from './store'
import App from './App.vue'
import Vuelidate from 'vuelidate'
import router from './router'
import vuetify from '@/plugins/vuetify'
import formioWidget from '@it-enterprise/formio-widget'

import { getClient } from './api/api'
import gql from 'graphql-tag'

const formioOptions = {
  auth,
  WsUrl: window.appConfig.WsUrl,
  GraphQlUrl: window.appConfig.GrapgQlUrl,
}

// import { apolloProvider } from '@/plugins/apollo'

// объект с зависимостями
let dependencies = {
  i18n,
  // apolloProvider,
  axios,
  store,
  router
}


// Плагины стандартные
Vue.use(Vuelidate)


// Плагины it-enterprise
Vue.use(GrapgQlCore, { options: window.appConfig, dependencies })
Vue.use(Localization, { dependencies })

Vue.prototype.$localization.RegisterLanguage('', 'ru', () => import('@/langs/ru.json'))
Vue.prototype.$localization.RegisterLanguage('', 'en', () => import('@/langs/en.json'))
Vue.prototype.$localization.RegisterLanguage('', 'uk', () => import('@/langs/uk.json'))

Vue.use(formioWidget, { formioOptions, dependencies, gqTools: { getClient, gql } })

// импорт компонентов
let req = require.context('@/components/', true, /\.(js|vue)$/i)
req.keys().map(key => {
  if (!(req(key).default || {}).name) {
    return
  }
  Vue.component(req(key).default.name, req(key).default)
})

// импорт страниц
req = require.context('@/pages/', true, /\.(js|vue)$/i)
req.keys().map(key => {
  if (!(req(key).default || {}).name) {
    return
  }
  Vue.component(req(key).default.name, req(key).default)
})


// импорт макетов
req = require.context('@/layout/', true, /\.(js|vue)$/i)
req.keys().map(key => {
  if (!(req(key).default || {}).name) {
    return
  }
  Vue.component(req(key).default.name, req(key).default)
})


registerAppRuntime.then(() => new Vue({
  i18n,
  router,
  store,
  vuetify,
  // apolloProvider,
  render: h => h(App)
}).$mount('#app'))

